module.exports = __webpack_public_path__ + "dimer/static/img/aboutBg1.8100eab.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/aboutBg1.jpg
// module id = YK2x
// module chunks = 0